import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

export default function EmptyList() {
  const { t } = useTranslation();
  return (
    <Paper>
      <Typography gutterBottom align="center" variant="subtitle1">
        {t('common.list_empty')}
      </Typography>
      <Typography variant="body2" align="center">
        {t('common.no_data_found')}
      </Typography>
    </Paper>
  );
}
